"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
const react_redux_1 = require("react-redux");
const index_1 = __importDefault(require("./index"));
const app_1 = require("ducks/app");
// ducks
const user_1 = require("ducks/user");
const app_2 = require("selectors/app");
// selectors
const user_2 = require("selectors/user");
const mapStateToProps = (state) => {
    return {
        initialValues: {
            receivesNewsletter: (0, user_2.getReceivesNewLetter)(state) || false,
            isLabRat: (0, user_2.getIsLabRat)(state) || false,
        },
        online: (0, app_2.online)(state),
    };
};
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = {
    submitPreferencesForm: user_1.submitPreferencesForm,
    showSaveNeeded: app_1.showSaveNeeded,
};
exports.default = (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps)(index_1.default);
